import { Injectable, Injector, inject } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { ApplicationCapabilitiesService } from '@core/auth/application-capabilities.service';
import { CAPABILITIES_PATH } from '@core/auth/application-capability';

/**
 * M2a: a 403 from the API means the UI may be offering something PM authority no longer allows,
 * so re-read the caller's capabilities. The service ignores this where authority is not enforced
 * (the deployed default makes no extra request) and while a read is already running; a 403 from
 * the capabilities read itself never triggers another. The error still reaches the caller.
 */
@Injectable({ providedIn: 'root' })
export class CapabilityRefreshInterceptor implements HttpInterceptor {
  // Resolved lazily: the capabilities service depends on HttpClient, which depends on interceptors.
  private readonly _injector = inject(Injector);

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        error: (error: unknown) => {
          if (
            error instanceof HttpErrorResponse &&
            error.status === HttpStatusCode.Forbidden &&
            !isCapabilitiesRead(req.url)
          ) {
            this._injector.get(ApplicationCapabilitiesService).refreshAfterDenial();
          }
        },
      })
    );
  }
}

/** The URL's path (without query or fragment) is the capabilities read, absolute or relative. */
function isCapabilitiesRead(url: string): boolean {
  return url.split(/[?#]/, 1)[0].endsWith(CAPABILITIES_PATH);
}
